import React from "react";

const Phone = () => (
  <svg
    width="72px"
    height="72px"
    viewBox="0 0 72 72"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    className="text-primary block"
  >
    <g
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <g strokeWidth="2">
        <g transform="translate(17.000000, 2.000000)">
          <path
            d="M34,0.25 L4,0.25 C1.92875,0.25 0.25,1.92875 0.25,4 L0.25,64 C0.25,66.07125 1.92875,67.75 4,67.75 L34,67.75 C36.07125,67.75 37.75,66.07125 37.75,64 L37.75,4 C37.75,1.92875 36.07125,0.25 34,0.25 L34,0.25 Z"
            id="Stroke-526"
            stroke="#5B5B5B"
          />
          <path d="M37.75,57.75 L0.25,57.75" stroke="#5B5B5B" />
          <path d="M37.75,10.25 L0.25,10.25" stroke="#5B5B5B" />
          <path d="M25.25,5.25 L17.75,5.25" stroke="#5B5B5B" />
          <path d="M12.75,5.25 L12.75,5.25" stroke="#5B5B5B" />
          <path d="M17.75,62.75 L20.25,62.75" stroke="#5B5B5B" />
          <path
            d="M22.8606237,35.8628013 L21.7199273,37.0690124 C21.1554502,37.63335 19.2110091,37.0139335 17.629825,35.4331402 C16.04923,33.8523469 15.4293658,31.9089755 15.9944321,31.3446378 L17.1345393,30.1381322 C17.4736381,29.7994118 17.4736381,29.2506848 17.1345393,28.9116699 L14.4762527,26.2540403 C14.1374485,25.9153199 13.5882912,25.9153199 13.2494871,26.2540403 L11.7154409,27.7871182 C10.0782804,29.4244631 11.2817507,34.2812831 15.0088907,38.0075019 C18.7357361,41.7334262 23.5747639,42.9179051 25.212219,41.2802657 L26.7456759,39.7471878 C27.0847747,39.4081728 27.0847747,38.8594458 26.7456759,38.5204309 L24.0873893,35.8628013 C23.7485852,35.5240809 23.1994279,35.5240809 22.8606237,35.8628013 Z"
            stroke="currentColor"
            fillOpacity="0.3"
            fill="currentColor"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default Phone;
